import { Inject, Injectable } from "@angular/core";
import { WindowToken } from "@app/util/window.token";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class KeyboardService {

    constructor(@Inject(WindowToken) private $window,
                @Inject(DOCUMENT) private $document: Document) {}

    forceCloseSoftKeyboard() {
        // assume the soft keyboard is open (because with mobile web there is no easy way to know)
        // create input to give focus then take away focus to ensure that the keyboard doesn't get 'stuck' open
        const softKeyboardCloseInput = this.$document.createElement("input");
        softKeyboardCloseInput.type = "text";
        softKeyboardCloseInput.id = "softKeyboardCloseInput";
        // position offscreen
        softKeyboardCloseInput.style.position = "absolute";
        softKeyboardCloseInput.style.top = "-9999px";
        softKeyboardCloseInput.style.left = "-9999px";
        this.$document.body.appendChild(softKeyboardCloseInput);

        // must delay a cycle/frame to work
        setTimeout(function () {
            // force soft keyboard to give this input focus
            softKeyboardCloseInput.focus();
            // close the soft keyboard by removing focus
            softKeyboardCloseInput.blur();
        }, 0);
    }
}

